import { render, staticRenderFns } from "./UserRankItem.vue?vue&type=template&id=be057e26&scoped=true"
import script from "./UserRankItem.vue?vue&type=script&lang=js"
export * from "./UserRankItem.vue?vue&type=script&lang=js"
import style0 from "./UserRankItem.vue?vue&type=style&index=0&id=be057e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be057e26",
  null
  
)

export default component.exports